function setValue<T, Key extends keyof T, Value extends T[Key]>(
	obj: T,
	key: Key,
	value: Value,
): void {
	obj[key] = value;
}

function setValueAndReturn<T, Key extends keyof T, Value extends T[Key]>(
	obj: T,
	key: Key,
	value: Value,
): T {
	obj[key] = value;
	return obj;
}

export const OBJECT_UTILITIES = { setValue, setValueAndReturn };
